'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import { SearchSuggestionsList } from '@/common/components/homeSearch/search-suggestions-list.component';
import { SearchLoadingOverlay } from '@/common/components/homeSearch/search-loading-overlay.component';
import { useAppbarSearch } from '@/common/components/homeSearch/hooks/use-appbar-search';
import Spinner from '@/common/components/spinner/spinner.component';
import SearchHeader from './search-header.component';

export default function Search() {
  const router = useRouter();
  const {
    isLoading,
    isNavigating,
    searchResults,
    beginNavigation,
    value,
    handleClearSearch,
    setValue,
    handleSearch,
    goToSearchPage,
  } = useAppbarSearch();

  return (
    <div className="flex min-h-dvh w-full flex-col bg-white lg:mx-auto lg:max-w-[1168px] lg:p-4">
      <div className="sticky top-0 z-40 shrink-0 border-b border-plp-border/60 bg-white">
        <SearchHeader
          isSearching={isLoading}
          clearSearch={handleClearSearch}
          value={value}
          autoFocus
          handleSubmit={goToSearchPage}
          onBack={() => {
            router.push('/');
          }}
          onChange={(e) => {
            setValue(e.target.value);
            handleSearch(e.target.value);
          }}
        />
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto px-4 pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-3">
        {isLoading ? (
          <div className="flex flex-col items-center justify-center gap-3 py-16">
            <Spinner
              containerClassName="!w-auto !h-auto"
              spinnerClassName="!h-10 !w-10 !text-plp-accent"
            />
            <p className="text-sm font-medium text-plp-secondary">
              در حال جستجو...
            </p>
          </div>
        ) : (
          searchResults?.data && (
            <SearchSuggestionsList
              value={value}
              data={searchResults.data}
              onNavigate={beginNavigation}
            />
          )
        )}
      </div>

      {isNavigating && <SearchLoadingOverlay />}
    </div>
  );
}
